// FilterDialog.js
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const FilterDialog = ({ open, onClose, filters, sortOrder, setSortOrder }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            fullScreen={true}
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    position: 'absolute',
                    bottom: 0,
                    margin: 0,
                    borderRadius: '10px 10px 0 0',
                    width: '100%',
                    height: 'auto',
                    maxHeight: '400px',
                },
            }}
            fullWidth={true}
        >
            <DialogTitle>{t(StringKeys.FILTER)}</DialogTitle>
            <DialogContent dividers={true} style={{ padding: '16px 24px', overflowY: 'auto' }}>
                {/* Sort Order Field */}
                <FormControl variant="outlined" size="small" fullWidth>
                    <InputLabel>{t(StringKeys.SORT)}</InputLabel>
                    <Select
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        label={t(StringKeys.SORT)}
                    >
                        <MenuItem value="asc">A-Z</MenuItem>
                        <MenuItem value="desc">Z-A</MenuItem>
                    </Select>
                </FormControl>
                {/* Additional filters can be rendered here */}
                {filters && filters.map((filter, index) => (
                    <div key={index} style={{ marginTop: '16px' }}>
                        {filter}
                    </div>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {t(StringKeys.CLOSE)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FilterDialog;
